// extracted by mini-css-extract-plugin
export default {"stickyFix":"TableByPaymentMethod_stickyFix__NdAbp","placeHolderShimmer":"TableByPaymentMethod_placeHolderShimmer__eC9kK"};